'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _recommendations = require('../actions/recommendations');

var Actions = _interopRequireWildcard(_recommendations);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var recommendationsOperations = require('../operations/recommendations');

/** *
 * recommendations reducer
 * @param state
 * @param action
 * @returns {*}
 */

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        recommendations: {}, contentMetaData: new Map(), isFetching: 0
    };
    var action = arguments[1];

    switch (action.type) {
        // ---------------------------------------------------------------------GET RECOMMENDATIONS PAGINATED-------------------------------------------------------------------
        case Actions.GET_RECOMMENDATIONS_PAGINATED_START:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching + 1
                });
            }

        case Actions.GET_RECOMMENDATIONS_PAGINATED_COMPLETE:
            {
                var newRecommendations = recommendationsOperations.mergeRecommendations(state, action.response);
                var newContentMetaData = recommendationsOperations.createContentMetaDataMap(state.contentMetaData, action.response);
                var newLastPageNumbersForCategories = recommendationsOperations.createLastPageNumberForCategoriesObject(state, action.response);
                var newCurrentPageNumberForCategories = recommendationsOperations.createCurrentPageNumberForCategoriesObject(state, action.response);

                return _extends({}, state, {
                    contentMetaData: newContentMetaData,
                    recommendations: newRecommendations,
                    lastPageNumbersForCategories: newLastPageNumbersForCategories,
                    currentPageNumberForCategories: newCurrentPageNumberForCategories,
                    isFetching: state.isFetching - 1
                });
            }

        case Actions.GET_RECOMMENDATIONS_PAGINATED_FAILURE:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching - 1
                });
            }
        // ---------------------------------------------------------------------GET RECOMMENDED CONTENTS-------------------------------------------------------------------
        case Actions.GET_RECOMMENDED_CONTENTS_START:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching + 1
                });
            }

        case Actions.GET_RECOMMENDED_CONTENTS_COMPLETE:
            {
                var recommendedContents = action.recommendedContents.map(function (x) {
                    return Object.assign({}, x, { contentKey: x.id });
                });
                var _newContentMetaData = recommendationsOperations.appendContentMetaData(state.contentMetaData, recommendedContents);

                return _extends({}, state, {
                    contentMetaData: _newContentMetaData,
                    isFetching: state.isFetching - 1
                });
            }

        case Actions.GET_RECOMMENDED_CONTENTS_FAILURE:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching - 1
                });
            }

        // ---------------------------------------------------------------------GET RECOMMENDED CONTENTS CHANNELS-------------------------------------------------
        case Actions.GET_RECOMMENDED_CONTENTS_CHANNEL_START:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching + 1
                });
            }

        case Actions.GET_RECOMMENDED_CONTENTS_CHANNEL_COMPLETE:
            {
                var _newContentMetaData2 = recommendationsOperations.appendContentMetaData(state.contentMetaData, action.channels);

                return _extends({}, state, {
                    contentMetaData: _newContentMetaData2,
                    isFetching: state.isFetching - 1
                });
            }

        case Actions.GET_RECOMMENDED_CONTENTS_CHANNEL_FAILURE:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching - 1
                });
            }

        // ---------------------------------------------------------------------DEFAULT-------------------------------------------------------------------
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/reducers/recommendations.js
// module id = 768
// module chunks = 0